import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckBox } from '../../../components/inputs/checkBox';

const GuestCountSelect = ({ totalGuests, onChange }) => {
  const { t } = useTranslation();

  const renderCheckboxes = () => {
    const checkboxes = [];
    const totalCheckboxes = 9;

    // eslint-disable-next-line no-unreachable-loop
    for (let i = 1; i <= totalCheckboxes; i += 1) {
      checkboxes.push(
        <div key={`${i}`} className="min-w-[2.25rem] text-left flex">
          <CheckBox
            checked={totalGuests === i}
            onClick={() => onChange(i)}
            title={i === totalCheckboxes ? t('products.moreThanMaxGuests') : `${i}`}
            labelTop
          />
        </div>,
      );
    }

    return (
      <>
        <div className="flex flex-row justify-between">
          {checkboxes.slice(0, Math.ceil(totalCheckboxes / 2))}
        </div>
        <div className="flex flex-row justify-between">
          {checkboxes.slice(Math.ceil(totalCheckboxes / 2))}
        </div>
      </>
    );
  };

  return (
    <div>
      <p className="font-primaryMedium text-primary text-base">
        {t('products.howManyPeopleAtTable')}
      </p>
      <p className="font-primaryRegular text-sm text-primaryOrange mb-2">
        {t('products.requiredTag')}
      </p>
      <div className="flex flex-row flex-wrap">{renderCheckboxes()}</div>
    </div>
  );
};

export default GuestCountSelect;
